import * as React from "react";

import Button from "../../../components/Button";
import {OptionFlagMultiUpdateParamActionType} from "../../../services/Client";
import {renderActionTypeLabel} from "./FlagActionSelection";

interface IFMUConfirmDialogProps {
    actionType: OptionFlagMultiUpdateParamActionType;
    itemsToUpdateCount: number;
    t: reactI18Next.TranslationFunction;
    backAction: () => void;
    onSubmit: () => void;
    loaderActive: boolean;
}

export const FMUConfirmDialog = (props: IFMUConfirmDialogProps) => {

    return (
        <>
            <div style={{ marginBottom: '20px' }}>
                <p>
                    <b>{props.t("PSL_WF_S_MULTI:ACTION_TYPE")}</b>
                    {': ' + renderActionTypeLabel(props.actionType, props.t)}
                </p>

                <p>
                    {props.t("PSL_WF_S_MULTI:SUBMIT_TOTAL_TXT") + ' '}
                    <b>{props.itemsToUpdateCount}</b>
                </p>
            </div>

            <div style={{ marginTop: '30px' }}>
                <Button
                    icon={'arrow left'}
                    onClick={props.backAction}
                    disabled={props.loaderActive}
                />
                <Button
                    icon={'arrow right'}
                    style={{ float: 'right' }}
                    onClick={props.onSubmit}
                    disabled={props.loaderActive}
                />
            </div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/MultipleFlagUpdate/FMUConfirmDialog.tsx